import React from "react";

function Scene() {
	return (
		<iframe
			src='https://my.spline.design/primitivescopy-281f583b9516daa86ae31e7a6b1128ab/'
			frameBorder='0'
			width='100%'
			height='100%'
			scrolling="no"
		></iframe>
	);
}

export default Scene;
